import { Modal, Table } from "antd";

function HasPlanModal({ open = false, onClose = () => {}, plans = [] }) {
  return (
    <Modal
      title={"These Users already has an Active Plan"}
      centered
      width={900}
      visible={open}
      onCancel={onClose}
      footer={null}
    >
      <Table
        dataSource={plans}
        rowKey={"user_email"}
        columns={[
          {
            title: "User",
            dataIndex: "user_email",
          },
          {
            title: "Mobile",
            dataIndex: "user_mobile",
          },
        ]}
        pagination={false}
      />
    </Modal>
  );
}

export default HasPlanModal;
